import env from '../../env';
import honghuConfig from './honghu';
import defaultConfig from './default';
var envPlatform = {
    honghu: env.isHonghu
    // hk: env.isHk
};
var configMap = {
    honghu: honghuConfig,
    // hk: hkConfig,
    default: defaultConfig
};
var platform = Object.keys(envPlatform).find(function (k) { return envPlatform[k]; });
export default configMap[platform || 'default'] || defaultConfig;
